module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Thin.f35e9611.otf";